export enum LicenceType {
  FREE = 1,
  SUBSCRIPTION = 2
}

export enum LicenceRate {
  MONTHLY = 1,
  YEARLY = 2
}

export enum LicenceCompany {
  ACTIVE = 1,
  INACTIVE = 2,
  EXPIRED = 3
}